import React from 'react';
import './EmptyStateComponent.scss';
import ScreenService from '../../services/ScreenService';

class EmptyStateComponent extends React.Component {
    constructor(props) {
        super(props);

        const hasEPG = window.__UpshowState && !!window.__UpshowState.settings.features.on_screen_menu;

        if (ScreenService.isVertical) {
            this.imageUrl = 'https://cdn.upshow.tv/ui-assets/No_Content_Vertical_Screen.jpg';
        } else if (hasEPG) {
            this.imageUrl = 'https://cdn.upshow.tv/ui-assets/Xumo_No_Content_EPG_Screen.png';
        } else {
            this.imageUrl = 'https://cdn.upshow.tv/ui-assets/Xumo_No_Content_Horizontal.jpg';
        }
    }

    render() {
        return (
            <div className='empty-state'>
                <img className='w-h-100' src={this.imageUrl} />
            </div>
        );
    }
}

export default EmptyStateComponent;
